import type { MouseEvent } from 'react';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import { horizontalScrollTabs } from '@alfa-bank/site-helpers-common/scroll/horizontal-scroll-tabs';
import { Stack } from '@alfa-bank/site-stack';

import styles from './styles/styles.css';
import type { TBaseOption, TCarousel } from './models';

export const Carousel = <T extends TBaseOption>({
    containerClassName,
    contentClassName,
    gridClassName,
    isCardUnselectable = false,
    isPreselected,
    options,
    renderCard,
}: TCarousel<T>) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [selectedCard, setSelectedCard] = useState<string>();

    const scrollCallback = useMemo(() => horizontalScrollTabs(wrapperRef), [wrapperRef]);

    const handleCardClick = (event: MouseEvent, value: string) => {
        const newValue = isCardUnselectable && value === selectedCard ? '' : value;

        setSelectedCard(newValue);
        scrollCallback(event as MouseEvent<HTMLElement>);
    };

    useLayoutEffect(() => {
        if (isPreselected) {
            setSelectedCard(options[0].value);
        }
    }, [options, isPreselected]);

    return (
        <div className={cn(containerClassName)}>
            <div ref={wrapperRef} className={cn(styles.carouselWrapper, styles.external)}>
                <Stack>
                    {zIndex => (
                        <div
                            className={cn(styles.content, styles.external, contentClassName)}
                            style={{ zIndex }}
                        >
                            <div className={cn(styles.grid, styles.external, gridClassName)}>
                                {options.map(option =>
                                    renderCard({
                                        isSelected: selectedCard === option.value,
                                        onClick: e => handleCardClick(e, option.value),
                                        option,
                                    })
                                )}
                            </div>
                        </div>
                    )}
                </Stack>
            </div>
        </div>
    );
};
